import { IMRBaseComponent } from "../../../../../common/base"

import { OPERATOR_NOTIFICATIONS_SERVICE_NAME } from "../../../../../../services/operator"
import { SYSTEM_SERVICE_NAME } from "../../../../../../services/system"
import { USER_SESSION_SERVICE_NAME } from "../../../../../../services/user-session"

import { OperatorDetailsNotificationsController } from "./operator-details.notifications.controller"

import './operator-details.notifications.scss'
import * as TEMPLATE from './operator-details.notifications.tpl.html'

export const COMPONENT_NAME: string = 'operatorDetailsNotifications'

export class OperatorDetailsNotificationsComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsNotificationsController,

            services: [
                OPERATOR_NOTIFICATIONS_SERVICE_NAME,
                SYSTEM_SERVICE_NAME,
                USER_SESSION_SERVICE_NAME
            ],

            template: TEMPLATE
        })
    }

}
